import type { SelfCheckoutStepKey } from "./selfCheckoutFlow";

/**
 * Canonical English step labels for the self-checkout progress header.
 *
 * Single source of truth consumed by BOTH bundles' locale files
 * (checkout `guestCheckout.stepLabels` and unauthenticated
 * `journeyCheckout.header.stepLabels`), so the surfaces cannot drift apart
 * again (the original "Billing information" vs "Billing" mismatch). Edit
 * here, never in the locale files.
 */
const SELF_CHECKOUT_STEP_LABELS: Record<SelfCheckoutStepKey, string> = {
  patientInfo: "Patient info",
  address: "Billing",
  sampleCollection: "Sample collection",
  payment: "Payment",
};

export { SELF_CHECKOUT_STEP_LABELS };
